export default {
  title: {
    id: 'bo_sellers-orders-drawers-order_recap-shipping_details-title',
    defaultMessage: 'Shipping details',
  },
  expectedShippingDate: {
    id: 'bo_sellers-orders-drawers-order_recap-shipping_details-expected_shipping_date',
    defaultMessage: 'Expected shipping date',
  },
  shippingProvider: {
    id: 'bo_sellers-orders-drawers-order_recap-shipping_details-shipping_provider',
    defaultMessage: 'Shipping provider',
  },
  trackingNumber: {
    id: 'bo_sellers-orders-drawers-order_recap-shipping_details-tracking_number',
    defaultMessage: 'Tracking number',
  },
  trackShipping: {
    id: 'bo_sellers-orders-drawers-order_recap-shipping_details-track-shipping',
    defaultMessage: 'Track shipping',
  },
} as const
